import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

type NavItem = {
  label: string;
  href: string;
  type: "anchor" | "page";
};

const navItems: NavItem[] = [
  { label: "Trang chủ", href: "#hero", type: "anchor" },
  { label: "Giới thiệu", href: "#about", type: "anchor" },
  { label: "Dịch vụ", href: "#services", type: "anchor" },
  { label: "Năng lực", href: "/nang-luc", type: "page" },
  { label: "Liên hệ", href: "#contact", type: "anchor" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNav = (item: NavItem) => {
    setMenuOpen(false);
    if (item.type === "page") {
      navigate(item.href);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    // anchor type
    if (location.pathname === "/") {
      const el = document.querySelector(item.href);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/");
      setTimeout(() => {
        const el = document.querySelector(item.href);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 400);
    }
  };

  const isActive = (item: NavItem) => {
    if (item.type === "page") return location.pathname === item.href;
    return location.pathname === "/";
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-md" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20">
        {/* Logo */}
        <button
          onClick={() => handleNav({ label: "Trang chủ", href: "#hero", type: "anchor" })}
          className="flex items-center gap-3 cursor-pointer"
        >
          <img
            src="https://static.readdy.ai/image/c43dd3b2b6fbcff1b6e6a251cdbd15c0/b341b5bc3acc6262cf0ddd69c309a9db.jpeg"
            alt="Logo Thuận Phát"
            className="h-12 w-auto object-contain"
          />
          <div className="flex flex-col text-left">
            <span
              className={`font-bold text-sm leading-tight transition-colors ${
                scrolled ? "text-[#0E5C3A]" : "text-white"
              }`}
            >
              THUẬN PHÁT
            </span>
            <span
              className={`text-xs leading-tight transition-colors ${
                scrolled ? "text-gray-500" : "text-white/80"
              }`}
            >
              Phòng Thí Nghiệm Vật Liệu
            </span>
          </div>
        </button>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <li key={item.href}>
              <button
                onClick={() => handleNav(item)}
                className={`text-sm font-medium transition-colors hover:text-[#D4A017] cursor-pointer whitespace-nowrap ${
                  isActive(item)
                    ? "text-[#D4A017]"
                    : scrolled
                    ? "text-gray-700"
                    : "text-white"
                }`}
              >
                {item.label}
              </button>
            </li>
          ))}
        </ul>

        {/* CTA Button */}
        <button
          onClick={() => handleNav({ label: "Liên hệ", href: "#contact", type: "anchor" })}
          className="hidden md:inline-flex items-center gap-2 bg-[#D4A017] text-white px-5 py-2.5 rounded-md text-sm font-semibold hover:bg-[#B8891A] transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-phone-line"></i>
          Liên hệ ngay
        </button>

        {/* Mobile Menu Toggle */}
        <button
          className={`md:hidden text-2xl cursor-pointer transition-colors ${
            scrolled ? "text-gray-700" : "text-white"
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={menuOpen ? "ri-close-line" : "ri-menu-line"}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 pb-4">
          {navItems.map((item) => (
            <button
              key={item.href}
              onClick={() => handleNav(item)}
              className={`block w-full text-left py-3 text-sm font-medium border-b border-gray-50 cursor-pointer transition-colors ${
                isActive(item)
                  ? "text-[#D4A017]"
                  : "text-gray-700 hover:text-[#0E5C3A]"
              }`}
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => handleNav({ label: "Liên hệ", href: "#contact", type: "anchor" })}
            className="mt-3 w-full bg-[#D4A017] text-white py-2.5 rounded-md text-sm font-semibold cursor-pointer whitespace-nowrap"
          >
            Liên hệ ngay
          </button>
        </div>
      )}
    </nav>
  );
}
